// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__xDb3H","total":"Cart_total__rypkz","actions":"Cart_actions__gOYVV","button--alt":"Cart_button--alt__FQgAG","button":"Cart_button__tDqM-"};